import { conversationUrl } from 'dashboard/helper/URLHelper';

export const THREAD_AT_QUERY_KEY = 'thread_at';

export const getRouteConversationParamKey = route => {
  if (route.params.conversation_id !== undefined) return 'conversation_id';
  if (route.params.conversationId !== undefined) return 'conversationId';
  if (route.params.id !== undefined) return 'id';
  return null;
};

export const getRouteConversationId = route => {
  const key = getRouteConversationParamKey(route);
  if (!key || route.params[key] === undefined) return null;
  return Number(route.params[key]);
};

export const getThreadNavigationConversationId = conversation =>
  conversation?.active_conversation_id || conversation?.id;

export const buildCanonicalConversationRoute = (route, listRow) => {
  const canonicalId = getThreadNavigationConversationId(listRow);
  const key = getRouteConversationParamKey(route);
  if (!key || !canonicalId) return null;
  if (Number(route.params[key]) === canonicalId) return null;

  return {
    name: route.name,
    params: { ...route.params, [key]: String(canonicalId) },
    query: { ...route.query },
  };
};

export const getThreadAtConversationId = route => {
  const threadAt = route.query?.[THREAD_AT_QUERY_KEY];
  if (!threadAt) return null;
  return Number(threadAt);
};

export const shouldCanonicalizeThreadRoute = (requestedId, listRow) => {
  if (!listRow) return false;
  const canonicalId = getThreadNavigationConversationId(listRow);
  return requestedId !== canonicalId;
};

export const getThreadAtForCanonicalRedirect = (requestedId, listRow) => {
  const canonicalId = getThreadNavigationConversationId(listRow);
  if (requestedId === canonicalId) return null;
  return requestedId;
};

export const buildRouteWithoutThreadAt = route => {
  if (!route.query?.[THREAD_AT_QUERY_KEY]) return null;

  const { [THREAD_AT_QUERY_KEY]: _threadAt, ...query } = route.query;
  return {
    name: route.name,
    params: route.params,
    query,
  };
};

export const isSameContactInboxThread = (currentChat, conversation) => {
  if (!currentChat?.inbox_id || !conversation?.inbox_id) return false;
  if (currentChat.inbox_id !== conversation.inbox_id) return false;

  const currentContactInboxId =
    currentChat.contact_inbox_id || currentChat.meta?.contact_inbox_id;
  const conversationContactInboxId =
    conversation.contact_inbox_id || conversation.meta?.contact_inbox_id;

  if (currentContactInboxId && conversationContactInboxId) {
    return currentContactInboxId === conversationContactInboxId;
  }

  return true;
};

export const buildThreadHistoryRouteParams = ({
  accountId,
  activeInbox,
  label,
  teamId,
  conversationType,
  foldersId,
  listRow,
  historyConversationId,
}) => {
  const canonicalId = getThreadNavigationConversationId(listRow);

  return {
    path: conversationUrl({
      accountId,
      activeInbox,
      id: canonicalId,
      label,
      teamId,
      foldersId,
      conversationType,
    }),
    query: {
      [THREAD_AT_QUERY_KEY]: String(historyConversationId),
    },
  };
};
